import React from 'react';
import { STATUS_OPTIONS } from '../invoicesTypes';
import styles from './InvoiceFilters.module.css';

interface InvoiceFiltersProps {
  search: string;
  onSearchChange: (v: string) => void;
  status: string;
  onStatusChange: (v: string) => void;
  dateFrom: string;
  onDateFromChange: (v: string) => void;
  dateTo: string;
  onDateToChange: (v: string) => void;
}

export const InvoiceFilters: React.FC<InvoiceFiltersProps> = ({
  search, onSearchChange,
  status, onStatusChange,
  dateFrom, onDateFromChange,
  dateTo, onDateToChange,
}) => {
  return (
    <div className={styles.filtersBar}>
      {/* Search */}
      <div className={styles.searchWrapper}>
        <svg className={styles.searchIcon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="11" cy="11" r="8" /><path d="M21 21l-4.35-4.35" />
        </svg>
        <input
          className={styles.searchInput}
          placeholder="Search invoices..."
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
        />
      </div>

      {/* Status dropdown */}
      <div className={styles.selectWrapper}>
        <select
          className={styles.select}
          value={status}
          onChange={(e) => onStatusChange(e.target.value)}
        >
          {STATUS_OPTIONS.map((s) => (
            <option key={s} value={s}>{s}</option>
          ))}
        </select>
        <svg className={styles.selectChevron} viewBox="0 0 24 24" fill="currentColor">
          <path d="M7 10l5 5 5-5z" />
        </svg>
      </div>

      {/* Date from */}
      <div className={styles.dateWrapper}>
        <input
          type="date"
          className={styles.dateInput}
          value={dateFrom}
          onChange={(e) => onDateFromChange(e.target.value)}
          placeholder="mm/dd/yyyy"
        />
        <svg className={styles.calIcon} viewBox="0 0 24 24" fill="currentColor">
          <path d="M20 3h-1V1h-2v2H7V1H5v2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 18H4V8h16v13z" />
        </svg>
      </div>

      {/* Date to */}
      <div className={styles.dateWrapper}>
        <input
          type="date"
          className={styles.dateInput}
          value={dateTo}
          onChange={(e) => onDateToChange(e.target.value)}
          placeholder="mm/dd/yyyy"
        />
        <svg className={styles.calIcon} viewBox="0 0 24 24" fill="currentColor">
          <path d="M20 3h-1V1h-2v2H7V1H5v2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 18H4V8h16v13z" />
        </svg>
      </div>
    </div>
  );
};
